import http from "../../http";
import { Funcoes } from "./entities/Funcoes";

const actions = {
  listar: async (state, { paginacao }) => {
    try {
      let params = {};
      if (paginacao) {
        params.per_page = paginacao.rowsPerPage;
        params.page = paginacao.page;
      }
      let resposta = await http.get(`apiv2/functions`, { params });

      resposta = resposta.data;
      let listaFuncoes = [];
      resposta.results.data.forEach((funcoesDTO) => {
        listaFuncoes.push(
          new Funcoes({
            id: funcoesDTO.id,
            codigo: funcoesDTO.code,
            nome: funcoesDTO.name,
            dataCriacao: funcoesDTO.created_at,
            vendor_id: funcoesDTO.vendor_id,
          })
        );
      });

      paginacao.page = resposta.results.current_page;
      paginacao.rowsPerPage = resposta.results.per_page;
      paginacao.rowsNumber = resposta.results.total;

      return {
        listaFuncoes,
        paginacao,
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
};

export const funcoes = {
  namespaced: true,
  actions,
};
